// @vue/component
export default {
  components: {
    // Spaces,
  },
  meta: {
    title: 'Home',
  },
  data() {
    return {
      hasSidebar: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.hasSidebar = document.getElementsByClassName('p-app-layout__sidebar').length > 0;
    });
  },
  computed: {
    classes() {
      return {
        'has-sidebar': this.hasSidebar,
      };
    },
  },
};
